import script from "./ProductionComponentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionComponentItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductionComponentItem.vue?vue&type=style&index=0&id=23ce7f22&lang=css"

const __exports__ = script;

export default __exports__